import { getQueryParam } from './query'
import { isFullPageLayout } from './flow'

function cancelRequests(cancelTokens) {
  if (cancelTokens) {
    cancelTokens.forEach((token) => {
      token.cancel()
    })
  }
}

function isShowFieldError(meta) {
  // Only shown after user has touched the field
  // Hide after user change the field
  return meta.touched && !(meta.active && meta.dirty)
}

// Back button should be hidden if the origin flow is a full page layout
const shouldHideBackButtonBasedOnReturnUri = () => {
  const returnUri = getQueryParam('returnUri') || ''
  return isFullPageLayout(returnUri)
}

export { cancelRequests, isShowFieldError, shouldHideBackButtonBasedOnReturnUri }
